import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import backgroundImage from '../assets/background/10.jpg';
import UsersServices from '../services/UsersServices';

const RSVPForm = () => {
    const [searchParams, setSearchParams] = useSearchParams(); // Get the search parameters object and a setter
    // Get the value of the 'id' parameter
    const id = searchParams.get('id');
    const numGuests = ['1', '2', '3'];
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);
    const [formData, setFormData] = useState({
      id: '',
      present: '',
      nom: '',     
      prenom: '',   
      guest: '',   
      numero: '',
      email: '',
      message: ''
    });
    useEffect(() => {
        if (id) {
        // L'id est présent dans l'URL
        console.log('ID trouvé dans URL:', id);
        fetchUser(id);
        } else {
        // Aucun id dans l'URL
        console.log('Aucun ID dans l URL');
        }
    }, [id]);

    // if(loading) {
    //     return <div>Chargement...</div>;
    // }

    const fetchUser = async (userId) => {
      setLoading(true);
      try {
          const userData = await UsersServices.getUserById(userId);
          setUser(userData);
          console.log("User data received:", userData);
          setFormData({
              ...formData,
              id: userData.id || '',
              nom: userData.nom || '',        
              prenom: userData.prenom || '',  
              guest: userData.guest || '',  
              numero: userData.numero || '',
              email: userData.email || '',
              present: userData.present || '',
              message: userData.messages || '',
          });
          console.log("Form data set to:", formData);
      } catch (error) {
          console.error('Erreur lors de la récupération:', error);
      } finally {
          setLoading(false);
      }
    };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Handle form submission here
    console.log('RSVP Data:', formData);
    try {
          const updateResponse = await UsersServices.updateUser(formData.id, formData);
          console.log("User data received:", updateResponse);
      } catch (error) {
          console.error('Erreur lors de la récupération:', error);
      } finally {
           // Set a timeout to ensure loading lasts for 15 seconds minimum
         setTimeout(() => {
              setLoading(false);
          }, 5000); // 15 seconds
      }
  };

  
  return (
    <section className="contact-section-six pull-up pt-0" id="contact">
      <div className="auto-container">
        <div className="outer-box wow fadeInUp">
          <div className="row g-0">
            <div className="form-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <div className="contact-form-three">
                  <h4 className="title">Will you attend?</h4>
                  {loading  ? 
                    (<div className="loading-container h-100" style={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center', 
                      padding: '20px'
                    }}>
                      <div>Chargement...</div>
                    </div>) 
                      : 
                    (<form onSubmit={handleSubmit} id="contact-form">
                    <input type="hidden" name="id" value={formData.id} />
                    <div className="row">
                      <div className="form-group col-lg-6 col-md-6 col-sm-6">
                        <div className="radio-box">
                          <label className="custom-radio-box-two">
                            Accept with pleasure
                            <input 
                              type="radio" 
                              name="present" 
                              value="present"
                              checked={formData.present === 'present'}
                              onChange={handleChange}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                      <div className="form-group col-lg-6 col-md-6 col-sm-6">
                        <div className="radio-box">
                          <label className="custom-radio-box-two">
                            Decline with regret
                            <input 
                              type="radio" 
                              name="present" 
                              value='decline'
                              checked={formData.present === 'decline'}
                              onChange={handleChange}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                      
                      <div className="form-group col-lg-12">
                        <div className="input-outer">
                          <input 
                            type="text" 
                            name="nom" 
                            placeholder="Your Name" 
                            value={formData.nom}
                            onChange={handleChange}
                            required 
                          />
                        </div>
                      </div>
                      <div className="form-group col-lg-12">
                        <div className="input-outer">
                          <input 
                            type="text" 
                            name="prenom" 
                            placeholder="Your Name" 
                            value={formData.prenom}
                            onChange={handleChange}
                            required 
                          />
                        </div>
                      </div>
                      
                      <div className="form-group col-lg-6">
                        <div className="input-outer">
                          <input 
                            type="tel" 
                            name="numero" 
                            placeholder="Phone" 
                            value={formData.numero}
                            onChange={handleChange}
                            required 
                          />
                        </div>
                      </div>
                      
                      <div className="form-group col-lg-6">
                        <div className="input-outer">
                          <input 
                            type="email" 
                            name="email" 
                            placeholder="Email" 
                            value={formData.email}
                            onChange={handleChange}
                            required 
                          />
                        </div>
                      </div>
                      
                      <div className="form-group col-lg-12">
                        <select 
                          className="custom-select"
                          name="guest"
                          value={formData.guest}
                          onChange={handleChange}
                        >
                          <option value="">Number Of Guests</option>
                          {numGuests.map((num) => (
                            <option key={num} value={num} selected={formData.guest === num}>
                              {num === '1' ? 'Only me' : `${num} Guests`}
                            </option>
                          ))}
                        </select>
                      </div>
                      
                      <div className="form-group col-lg-12">
                        <div className="input-outer">
                          <textarea 
                            name="message" 
                            placeholder="Message"
                            value={formData.message}
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </div>
                      
                      <div className="form-group col-lg-12">
                        <div className="input-outer">
                          <button type="submit" className="theme-btn btn-style-one">
                            <span className="btn-title">RSVP</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>)

                  }


                  
                </div>
              </div>
            </div>
            
            <div className="content-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <div className="bg bg-image" style={{backgroundImage: `${backgroundImage}`}}></div>
                <div className="icon-leave"></div>
                <div className="contact-btn">
                  <h6 className="title">Call us Now</h6>
                  <a href="tel:+36-55-540-069">+36 55 540 069</a>
                </div>
                <div className="content-box">
                  <h4 className="title">When</h4>
                  <div className="text">
                    15. October 2024. <br />
                    at 7 o'clock in the evening
                  </div>
                </div>
                <div className="content-box">
                  <h4 className="title">Where</h4>
                  <div className="text">
                    Villa Macadamiana second at Marianberg, <br />
                    Hilltop Dr Menomonee Falls, US
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RSVPForm;